import Papa from 'papaparse'

export { toTitleCase } from '../CsvInstructions/helpers'

export const headersWhiteList = [
  'first_name',
  'last_name',
  'username',
  'playbook',
  'voip_user_id',
  'external_system_id',
  'balto_cloud_access',
  'playbook_edit_access',
  'user_management_access',
  'user_status',
  'uncategorized_tags',
  'edit_qa',
  'edit_leaderboard',
  'realtime_coaching_access',
  'midcall_playbook_switching_enabled',
  'desktop_enterprise_enabled',
  'edit_qa_copilot',
  'hierarchy_manager',
  'screen_capture_enabled',
  'agent_gpt_access',
  'tools_editor',
  'complaints_enabled',
  'newrez_complaints_enabled',
  'outbound_campaign_editor',
  'togo_editor',
  // `manage_support_access` is intentionally NOT whitelisted — it's the same
  // Balto-admin-only single-user gate as `ai_agent`, and the bulk-upload
  // backend doesn't yet enforce a field-level admin restriction, so allowing
  // it via CSV would let a customer admin grant it to anyone in their org.
  'desired_username',
]

const isRowEmpty = (rowObject) =>
  Object.values(rowObject).every((value) => {
    if (value === undefined || value === null) {
      return true
    }
    return String(value).trim() === ''
  })

export default (rawCSVData, tagCategories) => {
  const headersWhiteListTransformed = headersWhiteList.concat(
    tagCategories.map((tagCategory) => tagCategory.name)
  )
  const parsedCSVData = Papa.parse(rawCSVData, {
    transform: (value) => (value == null ? '' : value.trim()),
  })
  const [headers = []] = parsedCSVData.data
  const csvRows = parsedCSVData.data.slice(1)
  const tagCategoryNames = tagCategories.map((tagCategory) => tagCategory.name)

  const filteredHeaders = headers.filter((header) => {
    if (headersWhiteListTransformed.includes(header)) {
      return true
    }
    if (header.slice(0, -1) === 'balto_tag_' && !Number.isNaN(header.slice(-1))) {
      return true
    }
    return false
  })

  const seenTagKeys = new Set()
  const tagsResult = []
  const configNamesSet = new Set()

  const recordTag = (tagName, categoryId) => {
    const cleanedTag = (tagName || '').trim()
    if (!cleanedTag) {
      return
    }
    const dedupeKey = `${cleanedTag}::${categoryId ?? 'none'}`
    if (seenTagKeys.has(dedupeKey)) {
      return
    }
    seenTagKeys.add(dedupeKey)
    tagsResult.push({ tag: cleanedTag, category_id: categoryId })
  }

  const users = []

  // Precompute header → column index so per-row population stays O(headers)
  // instead of O(headers²) via repeated indexOf calls.
  const headerIndexByName = new Map(headers.map((header, idx) => [header, idx]))

  csvRows.forEach((row, csvRowOffset) => {
    // The first data row in the file is "Row 1" to the user — the header is
    // implicit and doesn't need its own number.
    const csvRowNumber = csvRowOffset + 1
    const rowObject = {}
    filteredHeaders.forEach((header) => {
      const headerIndex = headerIndexByName.get(header)
      const rawValue = headerIndex !== undefined ? row[headerIndex] : undefined
      rowObject[header] = rawValue == null ? '' : rawValue
    })

    if (isRowEmpty(rowObject)) {
      return
    }

    rowObject._csvRowNumber = csvRowNumber

    if (rowObject.playbook) {
      configNamesSet.add(rowObject.playbook)
    }

    if (rowObject.uncategorized_tags) {
      rowObject.uncategorized_tags.split(',').forEach((tagName) => recordTag(tagName, null))
    }

    tagCategoryNames.forEach((categoryName, categoryIndex) => {
      const value = rowObject[categoryName]
      if (!value) {
        return
      }
      recordTag(value, tagCategories[categoryIndex].id)
    })

    users.push(rowObject)
  })

  return {
    tags: tagsResult,
    configNames: [...configNamesSet],
    users,
    headers: filteredHeaders,
  }
}
